module.exports = __webpack_public_path__ + "static/media/veridatum_screenshot.aa76c080.webp";